import { IApiResponse } from "@interfaces/generic/IApiResponse.ts"
import { IGetUserQrCodeResponseApi } from "@interfaces/IGetUserQrCodeResponseApi.ts"
import { IGetUserQrCodeResponseCli } from "@interfaces/IGetUserQrCodeResponseCli.ts"

export const GetUserQrCodeAdapter = (
	response: IApiResponse<IGetUserQrCodeResponseApi>
): IGetUserQrCodeResponseCli => {
	return response.data
}
